import { render, staticRenderFns } from "./PartsStoreOrderDetails.vue?vue&type=template&id=4d340813"
import script from "./PartsStoreOrderDetails.vue?vue&type=script&lang=js"
export * from "./PartsStoreOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./PartsStoreOrderDetails.vue?vue&type=style&index=0&id=4d340813&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports